module.exports = __webpack_public_path__ + "static/media/prev.cc0090f4.svg";